import { Components } from '../../common/interfaces';
export var Strings = {
  MISSING_CONTENT_ERROR: "".concat(Components.DEVICE_POLICY, " component requires heading and policyText to be passed in.")
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/commerce-utils/dist/esm/components/DevicePolicy/strings.js
// module id = 3975
// module chunks = 11